import { render, staticRenderFns } from "./hukou.vue?vue&type=template&id=4e88e222&scoped=true"
import script from "./hukou.vue?vue&type=script&lang=js"
export * from "./hukou.vue?vue&type=script&lang=js"
import style0 from "./hukou.vue?vue&type=style&index=0&id=4e88e222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88e222",
  null
  
)

export default component.exports